import styled from "styled-components";
import { ReactComponent as Swoosh1 } from "./assets/top-swoosh.svg";
import { ReactComponent as Swoosh2 } from "./assets/bottom-swoosh.svg";

export const Container = styled.div`
  position: relative;
  height: 100vh;
  width: 100%;
  background-color: #daf7ff;
  background-image: url(/assets/img/illustration/top-swoosh.svg);
  background-repeat: no-repeat;
  background-position: -30% -10%;

  @media only screen and (min-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const InnerContainer = styled.div`
  position: relative;
  padding: 80px 20px;
  z-index: 1;

  @media only screen and (min-width: 768px) {
    margin: 16vh 0;
    padding: 0px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 1016px;
  }
`;

export const Wrapper = styled.div``;

export const Title = styled.h1`
  font-family: Gilroy;
  padding: 0;
  margin: 0;
  font-size: 11px;
  color: #6a7481;
  font-family: 700;

  @media only screen and (min-width: 769px) {
    font-size: 13px;
    line-height: 20px;
    text-align: left;
    padding-bottom: 8px;
  }
`;

export const TitleSection = styled.h1`
  font-family: Gilroy;
  font-size: 14px;
  font-weight: 700;
  line-height: 19px;
  color: #1f2d3d;
  margin-top: 20px;

  @media screen and (max-height: 700px) {
    margin-top: 12px;
  }

  @media screen and (max-width: 400px) {
    font-size: 12px;
  }

  @media only screen and (min-width: 769px) {
    width: 550px;
    text-align: left;
    font-size: 18px;
    margin-top: 10px;
  }
`;

export const Description = styled.p`
  font-family: Gilroy;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: #6a7481;
  margin-bottom: 0;
  position: relative;
  /* z-index: 9; */

  @media screen and (max-width: 400px) {
    font-size: 12px;
  }

  @media only screen and (min-width: 769px) {
    font-size: 18px;
    line-height: 20px;
    padding-bottom: 8px;
  }
`;

export const TopSwoosh = styled(Swoosh1)``;

export const BottomSwoosh = styled(Swoosh2)`
  position: absolute;
  bottom: 0px;
  right: 0;
`;

export const BannerWrapper = styled.div`
  margin: 16px 0;
  height: 168px;
  border-radius: 16px;

  img {
    object-fit: cover;
    height: 168px;
    width: 100%;
    border-radius: 16px;
  }

  @media screen and (max-height: 700px) {
    margin: 8px 0;
  }

  @media only screen and (min-width: 768px) {
    height: 189px;

    img {
      object-fit: fill;
      border-radius: 16px;
      height: 189px;
    }
  }
`;

export const EmptyStateWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 12px 0;
  border-radius: 16px;
  padding-right: 12px;

  svg {
    object-fit: contain;
    border-radius: 16px;
    height: 45vh;
  }

  @media screen and (max-height: 700px) {
    margin: 12px 0;

    svg {
      width: 100%;
      height: 45vh;
    }
  }
`;

export const LoadingWrapper = styled.div`
  margin: 12px 0;

  @media screen and (max-height: 700px) {
    margin: 8px 0;
  }
`;

export const SliderContainer = styled.div`
  @media only screen and (min-width: 768px) {
    width: calc(100% + 96px);
    height: 20px;
    display: flex;
    justify-content: center;
  }
`;
